"use client"

import { GridSkeleton } from "@/app/nft/search/result/view/grid/grid"
import { TableSkeleton } from "@/app/nft/search/result/view/table/table"
import { ViewType } from "@/app/nft/search/result/view/view-selector/types"

interface Props {
  viewType: ViewType
}

export function LoadingView({ viewType }: Props) {
  return (
    <>{viewType === ViewType.GRID ? <GridSkeleton /> : <TableSkeleton />}</>
  )
}
